/* src/app/shared-components/add-edit-destinations/add-edit-destinations.component.scss */
.modal-button {
  display: flex;
  width: 100%;
  border: 0;
  text-align: start;
  cursor: unset;
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #2e2e38;
}
.is-placeholder {
  color: rgba(46, 46, 56, 0.32);
}
.modal-vh {
  height: 40vh;
  overflow: hidden;
}
.modal-overflow {
  overflow-y: scroll;
  overflow-x: hidden;
}
.modal-dropdown {
  position: relative;
  display: inline-block;
}
.modal-dropdown-caption {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: normal;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 0.5rem;
}
.modal-dropdown-selector {
  background-color: rgba(46, 46, 56, 0.08);
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
}
.modal-dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #f9f9f9;
  min-width: 10rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.2);
  padding: 0.75rem 1rem;
  z-index: 1;
}
.modal-dropdown.active .modal-dropdown-content {
  display: block;
}
.modal-body-content {
  padding: 0.5rem 0;
}
.root-element {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border: none !important;
  border-radius: 0;
  padding: 0.75rem 1rem;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.08);
}
.root-element:focus {
  outline: 0;
}
.root-element > .custom-control > .custom-control-label {
  vertical-align: middle;
}
.root-element-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.root-element-info > .ws-img {
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
}
.root-element-title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.root-element-title.active {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: bold;
}
.root-element .custom-checkbox {
  padding: 0;
}
.root-element .custom-checkbox .custom-control-input,
.root-element .custom-checkbox .custom-control-label,
.root-element .custom-checkbox .custom-control-label::before,
.root-element .custom-checkbox .custom-control-label::after {
  width: 1.25rem;
  height: 1.25rem;
}
.root-element .custom-checkbox .custom-control-label::before,
.root-element .custom-checkbox .custom-control-label::after {
  left: 0;
}
.root-icon {
  font-size: 1rem;
  line-height: 1rem;
  color: #747480;
  margin-right: 0.625rem;
  margin-left: 0.3125rem;
}
.root-icon.root-icon-variant {
  font-size: 1.5rem;
  line-height: 1.625rem;
  display: flex;
  align-items: center;
}
.root-children {
  padding-left: 2rem;
}
.check-selector::after {
  border: 0.125rem solid #72727f;
  border-radius: 3%;
}
button:not(:disabled),
[type=button]:not(:disabled) {
  cursor: unset;
}
/*# sourceMappingURL=add-edit-destinations.component.css.map */
